import React from "react";
import Banner from "./Banner";
import RegisterSteps from "./RegisterSteps";
import BookingViaDb from "./BookingViaDb";
import Bbclients from "./B2b";
import OnlineBooking from "./OnlineBooking";
import Help from "./Help";
import LandingFooter from "../../../components/landingFooter";
import AppHeader from "../../../components/Header";

const MobilePage = () => {
  return (
    <AppHeader>
      <Banner />
      <RegisterSteps />
      <BookingViaDb />
      <Bbclients />
      <OnlineBooking />
      <Help />
      {/* <LandingFooter /> */}
    </AppHeader>
  );
};

export default MobilePage;
